import React, { useState, useEffect } from 'react';
import './App.css';
import { Container, Nav, Navbar, Row, Col, Image, Accordion, Card, Button, Carousel } from 'react-bootstrap';
import 'animate.css';

function App() {
  return (
    <div>
      <Top />
      <ParallaxBienvenida />
      <Conocenos />
      <Productos />
      <Ubicacion />
      <Contacto />
      <Bottom />
    </div>
  );
}

function Top() {
  const [activeSection, setActiveSection] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['conocenos', 'productos', 'ubicacion', 'contacto'];
      let currentSection = '';
      
      sections.forEach((section) => {
        const el = document.getElementById(section);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= window.innerHeight && rect.bottom >= 0) {
            currentSection = section;
          }
        }
      });

      setActiveSection(currentSection);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Navbar variant="dark" sticky="top" expand="lg" className="custom-navbar">
      <Container>
        <Navbar.Brand href="#home">
          <img
            alt=""
            src={`${process.env.PUBLIC_URL}/img/logo.png`}
            width="30"
            height="30"
            className="d-inline-block align-top"
          />{' '}
          Droguería <h3>Santa Catalina Labouré</h3>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="#conocenos" className={activeSection === 'conocenos' ? 'text-light' : ''}>
              Conócenos
            </Nav.Link>
            <Nav.Link href="#productos" className={activeSection === 'productos' ? 'text-light' : ''}>
              Nuestros productos
            </Nav.Link>
            <Nav.Link href="#ubicacion" className={activeSection === 'ubicacion' ? 'text-light' : ''}>
              Ubicación
            </Nav.Link>
            <Nav.Link href="#contacto" className={activeSection === 'contacto' ? 'text-light' : ''}>
              Contacto
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

function Bottom() {
  return (
    <Navbar bg="light" data-bs-theme="light">
      <Container>
        <Navbar.Collapse className="justify-content-center">
          <Navbar.Text>© 2025 - Droguería Santa Catalina Labouré</Navbar.Text>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

function ParallaxBienvenida() {
  useEffect(() => {
    let hasScrolled = false;

    const handleScroll = () => {
      if (hasScrolled) return;

      const parallax = document.querySelector('.parallax');
      const conos = document.querySelector('#conocenos');

      if (parallax && conos) {
        const parallaxRect = parallax.getBoundingClientRect();

        if (parallaxRect.bottom < window.innerHeight) {
          hasScrolled = true;

          const conosOffsetTop = conos.offsetTop;

          const offsetAdjustment = 120;
          const finalScrollPosition = conosOffsetTop - offsetAdjustment;

          window.scrollTo({
            top: finalScrollPosition,
            behavior: 'smooth',
          });
        }
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="parallax">
      <Container className="text-center text-white parallax-content">
        <Row>
          <Col>
            <h1 className="display-1 animate__animated animate__fadeInDown welcome-heading">¡Bienvenido!</h1>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

function Conocenos(){
  return (
    <Container className="mt-5 mb-5" id="conocenos">
      <Row className="align-items-center mb-5">
        <Col>
          <div className="mb-3">
            <h1><i class="bi bi-person-lines-fill"></i> ¿Quiénes somos?</h1>
          </div>
          <p style={{ textAlign: "justify" }}>
            Somos una farmacia ubicada en el municipio de Villamaría 
            encargada de distribución de productos farmacéuticos y de 
            aseo personal de excelente calidad, la cual cuenta con un 
            personal de gran experiencia dispuesto a solucionar tus necesidades.
          </p>
        </Col>
        <Col xs={6} md={4}>
          <Image src={`${process.env.PUBLIC_URL}/img/img3.png`} rounded className="img-fluid"/>
        </Col>
      </Row>
      <Row className="align-items-center">
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header> <p class="h5">Misión</p> </Accordion.Header>
            <Accordion.Body>
              DROGUERÍA SANTA CATALINA LABOURÉ es una farmacia 
              con productos éticos, genéricos y de consumo, que 
              quiere satisfacer las necesidades de sus clientes 
              ofreciendo productos y servicios.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <Accordion.Header> <p class="h5">Visión</p> </Accordion.Header>
            <Accordion.Body>
              DROGUERÍA SANTA CATALINA LABOURÉ quiere ser una 
              farmacia sólida, reconocida por su excelente atención y 
              eficiencia con sus clientes, siendo una farmacia confiable, 
              segura y oportuna.
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Row>
    </Container>
  );
}

function Productos() {
  const prods = [
    {
      nombre: "Ensure Advance",
      desc: "Fórmula única con HMB*, que te ayuda a mantener y recuperar tu masa muscular. Ensure Advance contiene 28 vitaminas y minerales, 13g de proteína y es el único con HMB que mantiene la proteína de tus músculos para evitar su pérdida.",
      img: "p1.png",
      esDescFab: true
    },
    {
      nombre: "Glucerna",
      desc: "Con más de 30 estudios científicos que demuestran y respaldan los beneficios de sus nutrientes, Glucerna es un alimento especialmente formulado con carbohidratos modificados, que han demostrado que, como parte de un plan de alimentación para personas con diabetes, ayudan a controlar los niveles de glucosa la sangre1.​",
      img: "p2.png",
      esDescFab: true
    },
    {
      nombre: "Electrolit",
      desc: "Protege tu salud y la de tu familia. Cuando tú o tu familia se exponen a ambientes extremadamente cálidos puedes perder líquidos y electrolitos de forma intensa, la fórmula de Electrolit esta diseñada para cuidar tu salud en estas condiciones.",
      img: "p3.png",
      esDescFab: true
    },
    {
      nombre: "Noxpirin Plus Cápsulas",
      desc: "A los síntomas de la gripa les pone fin: dolor de cabeza y garganta, fiebre, lagrimeo, malestar general, estornudo y congestión nasal.",
      img: "p4.png",
      esDescFab: true
    },
    {
      nombre: "Bedoyecta Complejo B inyectable",
      desc: "Contiene Vitamina B12 + B6 + B1. Este producto requiere fórmula médica para su compra.",
      img: "p5.png",
      esDescFab: false
    },
    {
      nombre: "Iseptic Garganta",
      desc: "Iseptic Garganta es un producto que ayuda a aliviar el dolor de garganta, la tos y la irritación de la garganta.",
      img: "p6.png",
      esDescFab: false
    }
  ];

  const tarjetas = [];

  for (let i = 0; i < prods.length; i++) {
    const tarjeta = (
      <Carousel.Item>
        <div className="d-flex justify-content-center align-items-center mt-5 mb-5">
          <Card style={{ width: "30rem" }} data-bs-theme="light">
            <Card.Img
              variant="top"
              src={`${process.env.PUBLIC_URL}/img/${prods[i].img}`}
              alt={prods[i].nombre}
            />
            <Card.Body>
              <Card.Title>{prods[i].nombre}</Card.Title>
              <Card.Text>
                <p style={{ textAlign: "justify" }}> {prods[i].desc} 
                <br/> 
                </p>
                {prods[i].esDescFab && (
                  <figure class="text-end">
                    <figcaption class="blockquote-footer">
                      Descripción proporcionada por el fabricante.
                    </figcaption>
                  </figure>
                )}
                </Card.Text>
              <Button 
              variant="success" 
              href={`https://wa.me/message/HYIUCOECFCZWC1?text=${encodeURIComponent("¡Hola! Me interesa el producto " + prods[i].nombre + ".")}`}>
                Saber más
              </Button>
            </Card.Body>
          </Card>
        </div>
      </Carousel.Item>
    );
    tarjetas.push(tarjeta);
  }

  return (
    <Container className="mt-5 mb-5" id="productos">
      <Row className="align-items-center">
        <Col className="text-center">
          <div className="mb-3">
            <h1>
              <i className="bi bi-capsule-pill"></i> Nuestros productos
            </h1>
            <p class="lead">¡Contamos con una gran variedad de productos. Conozca los más vendidos!</p>
          </div>
        </Col>
      </Row>
      <Row className="align-items-center">
        <Col className="text-center">
          <Carousel data-bs-theme="dark" className="mb-4">
            {tarjetas.map((tarjeta, ii) => tarjeta)}
          </Carousel>
        </Col>
      </Row>
    </Container>
  );
}

function Ubicacion(){
  return(
    <Container className="mt-5 mb-5" id="ubicacion">
      <Row className="align-items-center">
        <Col className="text-end">
          <div className="mb-5">
            <h1>
              <i class="bi bi-geo-alt"></i> Ubicación
            </h1>
            <br/>
            <p class='lead'>Encuentranos en:</p>
          </div>
        </Col>
      </Row>
      <Row className="align-items-center">
        <Col>
          <div className="ratio ratio-16x9">
            <iframe 
            title="Ubicación"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d246.78085560086564!2d-75.51238700621542!3d5.043862619549733!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e47650019b82015%3A0x86cdfd95a7b47db!2sDroguer%C3%ADa%20Santa%20Catalina%20Laboure!5e1!3m2!1ses-419!2smx!4v1737592144294!5m2!1ses-419!2smx" 
            width="600" 
            height="450" 
            style={{border:0}} 
            allowfullscreen="" 
            loading="lazy" 
            referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div>
        </Col>
        <Col>
          <p class="lead" style={{ textAlign: "center" }}>
            Cl. 10 #5-75, Villamaría, Caldas, Colombia.
          </p>
          <p style={{ textAlign: "center" }}>
            De Lunes a Sábado en un horario de <u>8:00 a.m.</u> a <u>8:00 p.m.</u>
            <br/>
            Domingos y festivos de <u>10:00 a.m.</u> a <u>5:00 p.m.</u>
          </p>
        </Col>
      </Row>
    </Container>
  );
}

function Contacto(){
  return(
    <Container className="mt-5 mb-5" id="contacto">
      <Row className="align-items-center">
        <Col className="text-center">
          <div className="mb-5">
            <h1><i class="bi bi-telephone-fill"></i> Contacto</h1>
            <br/>
            <p class='lead'>¡Contáctanos!</p>
          </div>
        </Col>
      </Row>
      <Row className="align-items-center">
        <Col className="text-center">
          <Button variant="outline-primary" href='https://www.facebook.com/share/15BxMYPu82/' target="_blank">
            <p class="h3" style={{ textAlign: "center" }}><i class="bi bi-facebook"></i></p>
            <p>Droguería Santa <br/>Catalina Labouré</p>
          </Button>
        </Col>
        <Col className="text-center">
          <Button variant="outline-danger" href='https://www.rappi.com.co/tiendas/900435826-santacatalina-mt-nc' target="_blank" className="rappi-button">
            <p class="h5" style={{ textAlign: "center" }}><img src={`${process.env.PUBLIC_URL}/img/rappi.svg`} alt="Rappi svg de iconduck.com" width="50" height="50"/></p>
            <p>Santa Catalina<br/> Laboure</p>
          </Button>
        </Col>
        <Col className="text-center">
          <Button variant="outline-success" href='https://wa.me/message/HYIUCOECFCZWC1' target="_blank">
            <p class="h3" style={{ textAlign: "center"}}><i class="bi bi-whatsapp"></i></p>
            <p>+57 313 646 4583</p>
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default App;